export default __webpack_public_path__ + "static/media/frame_right_light.11257396.png";